// extracted by mini-css-extract-plugin
export default {"w-full":"ActiveCustomers_w-full__1gF-+","cardHead":"ActiveCustomers_cardHead__kye-m","cardTitle":"ActiveCustomers_cardTitle__XqPG9","chart":"ActiveCustomers_chart__Xo+BZ"};